// removed by extract-text-webpack-plugin
module.exports = {"tagList_tag":"Tags-m__tagList_tag___qY8W2","tagListTag":"Tags-m__tagList_tag___qY8W2"};


//////////////////
// WEBPACK FOOTER
// ./components/tags/Tags.m.sass
// module id = jCJ5
// module chunks = 0